import React, { useState } from "react"
import classNames from "classnames/bind"

import { CustomModal } from "../../../../assets/css/styled"
import { Card } from "../../../../components"
import { CloseIconSm } from "../../../../assets/svg"

import styles from "./styles.module.scss"

import SupportingInformation from "."

const cx = classNames.bind(styles)
interface SupportingInformationProps {
  supportingInformation: string
}
function SupportingInformationModal({
  supportingInformation
}: SupportingInformationProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOkModal = () => {
    setIsModalOpen(false)
  }
  const handleCancelModal = () => {
    setIsModalOpen(false)
  }
  return (
    <>
      <Card className={cx("sidebar-content", "onHover")} onClick={showModal}>
        <div className={cx("briefing-button")}>Supporting information</div>
      </Card>
      <CustomModal
        title="Supporting information"
        centered
        closeIcon={<CloseIconSm />}
        open={isModalOpen}
        onOk={handleOkModal}
        onCancel={handleCancelModal}
        className={cx("briefing-modal")}
      >
        <SupportingInformation
          modal
          supportingInformation={supportingInformation}
        />
      </CustomModal>
    </>
  )
}

export default SupportingInformationModal
